import { apiClient } from "./client";
import type {
  Simulator,
  SimulatorCreate,
  SimulatorUpdate,
  SimulatorsPaginated,
  SimulatorWithVersions,
  SimulatorStatus,
  MessageResponse,
} from "@/types";

interface ListSimulatorsParams {
  page?: number;
  page_size?: number;
  search?: string;
  status?: SimulatorStatus;
  include_unpublished?: boolean;
}

export async function listSimulators(
  params: ListSimulatorsParams = {}
): Promise<SimulatorsPaginated> {
  const response = await apiClient.get<SimulatorsPaginated>("/simulators", { params });
  return response.data;
}

export async function getSimulator(simulatorId: number): Promise<SimulatorWithVersions> {
  const response = await apiClient.get<SimulatorWithVersions>(
    `/simulators/${simulatorId}`
  );
  return response.data;
}

export async function createSimulator(data: SimulatorCreate): Promise<Simulator> {
  const response = await apiClient.post<Simulator>("/simulators", data);
  return response.data;
}

export async function updateSimulator(
  simulatorId: number,
  data: SimulatorUpdate
): Promise<Simulator> {
  const response = await apiClient.patch<Simulator>(
    `/simulators/${simulatorId}`,
    data
  );
  return response.data;
}

export async function deleteSimulator(simulatorId: number): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/simulators/${simulatorId}`
  );
  return response.data;
}

export async function restoreSimulator(simulatorId: number): Promise<Simulator> {
  const response = await apiClient.post<Simulator>(
    `/simulators/${simulatorId}/restore`
  );
  return response.data;
}

export async function permanentlyDeleteSimulator(simulatorId: number): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(
    `/simulators/${simulatorId}/permanent`
  );
  return response.data;
}

